<script>
    import { onMount } from 'svelte';
    
    let dropdownEl;
    
    onMount(() => {
        if (typeof bootstrap !== 'undefined') {
            const dropdown = new bootstrap.Dropdown(dropdownEl);
        }
    });
</script>

<div class="email-container">
    <!-- Desktop view -->
    <div class="email-badge desktop-view">
        <img src="/img/mail-line.svg" width="16" height="16" alt="E-Mail Icon" />
        <div class="email-text">
            {window.app.creds ? window.app.creds.email : ""}
        </div>
    </div>
    
    <!-- Mobile view -->
    <div class="mobile-view">
        <button 
            class="btn dropdown-toggle email-toggle" 
            type="button" 
            id="emailDropdown" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
            bind:this={dropdownEl}>
            <img src="/img/mail-line.svg" width="16" height="16" alt="E-Mail Icon" />
        </button>
        <ul class="dropdown-menu" aria-labelledby="emailDropdown">
            <li>
                <span class="dropdown-item">
                    {window.app.creds ? window.app.creds.email : ""}
                </span>
            </li>
        </ul>
    </div>
</div>

<style>
    .email-container {
        position: relative;
    }

    .email-badge {
        background-color: #d9e7cb;
        padding: 0.7rem 1rem;
        border-radius: 20px;
        font-size: 0.85rem;
        text-align: center;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 100%;
    }

    .email-toggle {
        background: none;
        border: none;
        padding: 0;
    }

    .dropdown-toggle {
        background-color: #d9e7cb;
        border-radius: 20px;
        padding: 0.7rem 1rem;
        font-size: 0.85rem;
        text-align: center;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
    
    .dropdown-toggle::after {
        display: none;
    }

    .dropdown-menu {
        background-color: #d9e7cb;
        border-radius: 10px;
        font-size: 0.85rem;
        min-width: auto;
        white-space: nowrap;
    }
    
    .dropdown-item {
        padding: 0.5rem 1rem;
        cursor: default;
    }
    
    .dropdown-item:hover, .dropdown-item:focus {
        background-color: transparent;
    }

    .email-text {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    /* Show desktop view only on large screens */
    .desktop-view {
        display: none;
    }

    /* Show mobile view only on small screens */
    .mobile-view {
        display: none;
    }

    @media (min-width: 1080px) {
        .desktop-view {
            display: flex;
        }
        
        .mobile-view {
            display: none;
        }
    }

    @media (max-width: 1080px) {
        .desktop-view {
            display: none;
        }
        
        .mobile-view {
            display: block;
        }
    }
</style>
